import { useState } from "react";
import {
  ResponseGetTransportationOptions,
  TransportationOptionsApi,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiGetTransportationOptions = () => {
  const [transList, setTransList] = useState<
    ResponseGetTransportationOptions[] | null
  >([]);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const fetchTransportationOptions = async () => {
    setIsLoading(true);
    setError(null);

    try {
      const config = createConfiguration();

      const api = new TransportationOptionsApi(config);
      const response = await api.transportationOptionsGetAllGet();
      setTransList(response);
      return response;
    } catch (err) {
      setError("配送方法の取得に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { transList, fetchTransportationOptions, error, isLoading };
};
